import { LineStyle, Timeline, TrendingUp } from "@material-ui/icons";
import React from "react";
import { Link } from "react-router-dom";
import "./sidebar.css";
const Sidebar = () => {
  return (
    <div className="sidebar">
      <div className="sidebar_wrapper">
        <div className="sidebar_menu">
          <h3 className="sidebar_title">Dashboard</h3>
          <ul className="sidebar_list">
            <Link to="/">
              <li className="sidebar_list_item">
                <LineStyle className="sidebar_icon" />
                Home
              </li>
            </Link>
            <li className="sidebar_list_item">
              <Timeline className="sidebar_icon" />
              Analytics
            </li>
            <Link to="/user">
              <li className="sidebar_list_item">
                <TrendingUp className="sidebar_icon" />
                User
              </li>
            </Link>
            <Link to="/product">
              <li className="sidebar_list_item">
                <TrendingUp className="sidebar_icon" />
                Product
              </li>
            </Link>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
